<template>
    <section class="list">
        <ul>
            <li
                    class="flex flex-main-justify"
                    v-for="article in relvantNewsData"
                    @click="goPath(article)"
                    :key="article.id"
                >
                <!-- 直播 -->
                <!-- liveType直播类型 1有视频无图 2有图无视频 3无图无视频 -->
                <!-- liveStatus || status直播状态 1预告 2直播中 3已结束 -->
                <!-- <div v-if="article.type === 'live'" style="width:100%">
                    <div class="title"><span class="tag_label" v-if="article.tags">{{article.tags}}</span>{{article.title}}</div>     
                    <div class="pic-wrap" v-if="article.liveType != 3 && article.imageUrl">
                        <img :src="article.imageUrl[0]" alt="">
                        <div v-if="article.liveStatus === '2'" class="living-label"></div>
                        <div v-else-if="article.liveStatus === '1'" class="live-label">预告</div>
                        <div v-else-if="article.liveStatus === '3'" class="live-label">直播回顾</div>
                    </div>
                    <div class="flex flex-main-justify date">
                        <span>{{getDate(article.date) | dateCompared}}</span>
                        <span v-if="article.hits > 0">{{article.hits}}人参与</span>
                    </div>
                </div> -->
                <!-- 三图 -->
                <!-- <div v-else-if="article.viewType==='three'" style="height:100%;width:100%;">
                    <div class="title"><span class="tag_label" v-if="article.tags">{{article.tags}}</span>{{article.title}}</div>
                    <div class="three-list flex">
                        <div class="img" v-for="img in article.imageUrl" :key="img" :style="{backgroundImage: 'url(' + img + ')'}"></div>
                        <div class="images-label" v-if="article.type === 'image'&&article.medias.length>3">{{article.medias.length}}图</div>
                    </div>
                    <div class="flex flex-cross-center date">
                        <span class="category_label" v-if="article && article.source" >{{article.source}}
                        </span>
                        <span>{{getDate(article.date) | dateCompared}}</span>
                    </div>
                </div> -->
                <!-- <template v-else-if="article.viewType==='banner'">
                    
                    <div v-if="article.type === 'normal'" style="height:100%">
                        <div class="title"><span class="tag_label" v-if="article.tags">{{article.tags}}</span>{{article.title}}</div>
                        <div class="pic-wrap">
                            <img :src="article.image" alt="">
                        </div>
                        <div class="description" v-html="article.description"></div>
                        <div class="flex flex-cross-center date">
                            <span class="category_label" v-if="article && article.source" >{{article.source}}
                            </span>
                            <span>{{getDate(article.date) | dateCompared}}</span>
                        </div>
                    </div>
                    
                    <div v-else-if="article.type === 'video'" style="height:100%">
                        <div class="title"><span class="tag_label" v-if="article.tags">{{article.tags}}</span>{{article.title}}</div>
                        <div class="pic-wrap">
                            <img :src="article.imageUrl[0]" alt="">
                            <i class="content-button"></i>
                        </div>
                        <div class="flex flex-cross-center date">
                            <span class="category_label" v-if="article && article.source" >{{article.source}}
                            </span>
                            <span>{{getDate(article.date) | dateCompared}}</span>
                        </div>
                    </div>  -->
                    <!-- 专题 -->
                    <!-- <div v-else-if="article.type === 'subject'">
                        <div class="title"><span class="tag_label" v-if="article.tags">{{article.tags}}</span>{{article.title}}</div>
                        <subjectSwipe :bannerUrl="article.bannerUrl"></subjectSwipe>
                    </div> -->
                    <!-- <template  v-else-if="article.type === 'subject'">
                        <div class="info">
                            <div class="title mult_line_ellipsis"><span class="tag_label_2" v-if="article.tags">{{article.tags}}</span>{{article.title}}</div>
                            <div class="date ellipsis">
                                <div
                                    class="category_label"
                                    v-if="article && article.source"
                                >{{article.source}}</div>
                                {{getDate(article.date) | dateCompared}}
                            </div>
                        </div>
                        <div class="thumbnail" :style="{backgroundImage: 'url(' + article.imageUrl[0] + ')'}" v-if="article.imageUrl && article.imageUrl.length>0">
                            <i :class="[article.type+'-icon']"></i>
                        </div>
                    </template>
                    <div v-else style="height:100%">
                        <div class="title"><span class="tag_label" v-if="article.tags">{{article.tags}}</span>{{article.title}}</div>
                        <div class="pic-wrap" v-if="article.imageUrl">
                            <img :src="article.imageUrl[0]" alt="">
                            <div class="images-label" v-if="article.type === 'image'&&article.medias.length>3">{{article.medias.length}}图</div>
                        </div>
                        <div class="flex flex-cross-center date">
                            <span class="category_label" v-if="article && article.source" >{{article.source}}
                            </span>
                            <span>{{getDate(article.date) | dateCompared}}</span>
                        </div>
                    </div> 
                </template> -->
                <!-- <div v-else-if="article.viewType === 'bigimage' && article.type === 'subject'">
                    <div class="title"><span class="tag_label" v-if="article.tags">{{article.tags}}</span>{{article.title}}</div>
                        <div class="pic-wrap" v-if="article.imageUrl">
                            <img :src="article.imageUrl[0]" alt="">
                        </div>
                </div>
                <div v-else-if="article.viewType === 'image' && article.type === 'subject'" class="image-title-wrap">
                    <img :src="article.imageUrl[0]" alt="">
                </div> -->
                <!-- 图集 -->
                <!-- <div v-else-if="article.type === 'image'">
                    <div class="title" v-html="article.title"></div>
                    <div class="flex images-list">
                        <div class="images" v-for="img in article.medias.slice(0,4)" :style="{backgroundImage: 'url(' + img.image + ')'}"></div>
                        <div class="images-label" v-if="article.medias.length>3">{{article.medias.length}}图</div>
                    </div>
                </div> -->
                <!-- 左文右图-->
                <template>
                    <div class="info">
                        <div :class='[ "title", "mult_line_ellipsis",article.images && article.images.length>0?"min_height":article.imageUrl?"min_height":"",]'><span class="tag_label_2" v-if="article.type==='subject'">{{article.tags}}</span>{{article.listTitle}}</div>
                        <div class="flex-default date" style=' justify-content: flex-start'>
                            <div class="tag ellipsis">
                                <span 
                                    class="tag-red"  
                                    v-if="article.type !='subject'" v-html="article.tags"
                                ></span>
                                <span v-html="article.source"></span>
                            </div>
                            <time>{{getDate(article.date) | dateCompared}}</time>
                        </div>
                    </div>
                    <div class="thumbnail" :style="{backgroundImage: 'url(' + article.imageUrl[0] + ')'}" v-if="article.imageUrl && article.imageUrl.length>0">
                        <i :class="[article.type+'-icon']"></i>
                    </div>
                </template>
            </li>
        </ul>
    </section>
</template>

<script>
import api from "src/constants/appapi";
// import audio from "_images/btn_audio@2x.png";
import subjectSwipe from "./com-list-swipe";
export default {
    props: ["relvantNewsData"],
    data() {
        return {
            isSharePage: false, // 是否为分享页面
        }
    },

    created() {
        window.appapi = api;
        this.isSharePage = appapi.isSharePage();
    },

    mounted() {},

    methods: {
        
        getDate: (date) => {
            return date.slice(0, -2) + ':00'
        },

        goPath (article) {
            if (!this.isSharePage) {
                const { articleId, type, sysCode } = article;
                const obj = {
                    articleId: articleId,
                    type: type,
                    sysCode: sysCode
                }
                window.appapi.appPostMessage("goNewsDetail", JSON.stringify(obj));
            }else {
                window.location.href = article.shareUrl
            }
        }  
        
        // getType (obj) {

        //     return 'video-bg'
        // }
    },
    components:{
        subjectSwipe
    }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~src/stylus/mixin"
@import "~src/stylus/reset";
@import "~src/stylus/list";
.list 
    margin-top 50px
</style>


// WEBPACK FOOTER //
// com-list.vue?e81bdaa0